/* eslint-disable */
// Cópia de exports/tenant-theme.js do design system OneWork (motor de tema por
// empresa, sem dependências), exposta como módulo ES. Não edite a lógica aqui:
// atualize a partir do design system.
/* OneWork — motor de tema por empresa (white-label). Sem dependências.
 * deriveTenantTheme({ primary, secondary, textColor }) → { vars: { '--ow-…': '#…' }, report }
 * applyTenantTheme(el, input) aplica as vars em el.style (padrão: document.documentElement). */
var OWTheme = (function () {
  var DEFAULT_PRIMARY = '#000229';
  var INK = '#1E2124';      /* --ft-n900 */
  var WHITE = '#FFFFFF';
  var PAGE = '#F7F6F2';     /* --ft-s50, fundo de página */
  var SUCCESS = ['#1D770D', '#2BBE41']; /* --ft-p800, --ft-p500 */
  var DANGER = ['#B73644', '#EA3D4E'];  /* --ft-a600, --ft-a400 */
  var STEPS = [['50', .975], ['100', .945], ['200', .89], ['300', .80], ['400', .70], ['500', .60], ['600', .51], ['700', .42], ['800', .33], ['900', .25], ['950', .18]];

  function clamp(x, a, b) { return Math.min(b, Math.max(a, x)); }
  function hexToRgb(h) {
    var rm = String(h || '').match(/^rgba?\(\s*(\d+)[\s,]+(\d+)[\s,]+(\d+)/i);
    if (rm) return [rm[1] / 255, rm[2] / 255, rm[3] / 255];
    h = String(h || '').trim().replace('#', '');
    if (h.length === 3) h = h.split('').map(function (c) { return c + c; }).join('');
    if (!/^[0-9a-fA-F]{6}$/.test(h)) return null;
    return [0, 2, 4].map(function (i) { return parseInt(h.substr(i, 2), 16) / 255; });
  }
  function rgbToHex(rgb) { return '#' + rgb.map(function (v) { var s = Math.round(clamp(v, 0, 1) * 255).toString(16); return s.length < 2 ? '0' + s : s; }).join('').toUpperCase(); }
  function toLin(c) { return c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4); }
  function toGam(c) { return c <= 0.0031308 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055; }
  function rgbToOklch(rgb) {
    var r = toLin(rgb[0]), g = toLin(rgb[1]), b = toLin(rgb[2]);
    var l = Math.cbrt(0.4122214708 * r + 0.5363325363 * g + 0.0514459929 * b);
    var m = Math.cbrt(0.2119034982 * r + 0.6806995451 * g + 0.1073969566 * b);
    var s = Math.cbrt(0.0883024619 * r + 0.2817188376 * g + 0.6299787005 * b);
    var L = 0.2104542553 * l + 0.7936177850 * m - 0.0040720468 * s;
    var A = 1.9779984951 * l - 2.4285922050 * m + 0.4505937099 * s;
    var B = 0.0259040371 * l + 0.7827717662 * m - 0.8086757660 * s;
    var H = Math.atan2(B, A) * 180 / Math.PI; if (H < 0) H += 360;
    return { L: L, C: Math.sqrt(A * A + B * B), H: H };
  }
  function oklchToRgbRaw(o) {
    var a = o.C * Math.cos(o.H * Math.PI / 180), b = o.C * Math.sin(o.H * Math.PI / 180);
    var l = Math.pow(o.L + 0.3963377774 * a + 0.2158037573 * b, 3);
    var m = Math.pow(o.L - 0.1055613458 * a - 0.0638541728 * b, 3);
    var s = Math.pow(o.L - 0.0894841775 * a - 1.2914855480 * b, 3);
    return [4.0767416621 * l - 3.3077115913 * m + 0.2309699292 * s, -1.2684380046 * l + 2.6097574011 * m - 0.3413193965 * s, -0.0041960863 * l - 0.7034186147 * m + 1.7076147010 * s].map(toGam);
  }
  function inGamut(rgb) { return rgb.every(function (v) { return v >= -0.0005 && v <= 1.0005; }); }
  /* converte reduzindo croma até caber no sRGB (mantém L e H) */
  function oklchToHex(o) {
    var c = o.C, rgb = oklchToRgbRaw(o);
    while (!inGamut(rgb) && c > 0) { c = Math.max(0, c - 0.002); rgb = oklchToRgbRaw({ L: o.L, C: c, H: o.H }); }
    return rgbToHex(rgb);
  }
  function lum(hex) { var rgb = hexToRgb(hex) || [1, 1, 1]; return 0.2126 * toLin(rgb[0]) + 0.7152 * toLin(rgb[1]) + 0.0722 * toLin(rgb[2]); }
  function contrast(a, b) { var x = lum(a), y = lum(b); return (Math.max(x, y) + 0.05) / (Math.min(x, y) + 0.05); }
  function hueDist(a, b) { var d = Math.abs(a - b) % 360; return d > 180 ? 360 - d : d; }
  function withL(hex, L) { var o = rgbToOklch(hexToRgb(hex)); return oklchToHex({ L: clamp(L, 0, 1), C: o.C, H: o.H }); }
  /* escurece (dir=-1) ou clareia (+1) em passos de L até contrast(cor, contra) >= alvo */
  function pushUntil(hex, against, target, dir) {
    var o = rgbToOklch(hexToRgb(hex)), L = o.L, out = hex, i = 0;
    while (contrast(out, against) < target && i++ < 100) { L = clamp(L + dir * 0.01, 0, 1); out = oklchToHex({ L: L, C: o.C, H: o.H }); }
    return out;
  }
  function onColor(fill) { return contrast(fill, WHITE) >= contrast(fill, INK) ? WHITE : INK; }
  /* Família semântica: tom a menos de 35° do success (verde) ou 15° do danger (vermelho), croma ≥ .06 */
  function semanticClash(hex) {
    var o = rgbToOklch(hexToRgb(hex));
    if (o.C < 0.06) return null;
    var near = function (list, deg) { return list.some(function (s) { return hueDist(o.H, rgbToOklch(hexToRgb(s)).H) < deg; }); };
    if (near(SUCCESS, 35)) return 'success';
    if (near(DANGER, 15)) return 'danger';
    return null;
  }
  function scale(hex) {
    var o = rgbToOklch(hexToRgb(hex)), out = {}, best = null, bestD = 9;
    STEPS.forEach(function (s) {
      var mid = 1 - Math.abs(s[1] - 0.55) * 1.1;          /* croma máximo no meio da escala */
      var C = Math.max(0.012, o.C * clamp(mid + 0.25, 0.25, 1.15));
      if (s[1] > 0.93) C = Math.min(C, 0.03);              /* fundos suaves quase neutros */
      out[s[0]] = oklchToHex({ L: s[1], C: C, H: o.H });
      var d = Math.abs(s[1] - o.L); if (d < bestD) { bestD = d; best = s[0]; }
    });
    out[best] = rgbToHex(hexToRgb(hex));                   /* a cor informada entra exata */
    return { steps: out, anchor: best };
  }
  /* hover/pressed: fundos escuros (L < .40) clareiam — escurecer um quase-preto não aparece;
     claros e médios escurecem. pressed fica entre o repouso e o hover nos escuros, além do hover nos claros. */
  function state(fill, on, kind) {
    var o = rgbToOklch(hexToRgb(fill));
    var dark = o.L < 0.4, dir = dark ? 1 : -1;
    var d = dark ? (kind === 'hover' ? 0.11 : 0.06) : (kind === 'hover' ? 0.06 : 0.11);
    for (var i = 0; i < 12; i++) {
      var c = oklchToHex({ L: clamp(o.L + dir * d, 0, 1), C: o.C, H: o.H });
      if (contrast(c, on) >= 4.5) return c;
      d *= 0.7;
    }
    return fill;
  }

  function deriveTenantTheme(input) {
    input = input || {};
    var report = [];
    var brand = hexToRgb(input.primary) ? rgbToHex(hexToRgb(input.primary)) : DEFAULT_PRIMARY;
    if (!hexToRgb(input.primary)) report.push('Sem cor primária válida: tema OneWork.');
    var secondary = hexToRgb(input.secondary) ? rgbToHex(hexToRgb(input.secondary)) : null;

    /* 1. cor de ação: a primária, salvo se colidir com success/danger */
    var action = brand, clash = semanticClash(brand), guard = null;
    if (clash) {
      if (secondary && !semanticClash(secondary) && rgbToOklch(hexToRgb(secondary)).C >= 0.04) { action = secondary; guard = 'secondary'; }
      else { action = DEFAULT_PRIMARY; guard = 'default'; }
      report.push('Primária próxima de ' + clash + ': ações usam ' + (guard === 'secondary' ? 'a cor secundária' : 'o azul OneWork') + '; a primária fica na área de marca.');
    }
    /* 2. preenchimento + texto sobre ele (claro/escuro automático, AA) */
    var fill = action, on = onColor(fill);
    if (contrast(fill, on) < 4.5) {
      var dark = pushUntil(fill, WHITE, 4.5, -1), light = pushUntil(fill, INK, 4.5, 1);
      var dD = Math.abs(rgbToOklch(hexToRgb(dark)).L - rgbToOklch(hexToRgb(fill)).L);
      var dL = Math.abs(rgbToOklch(hexToRgb(light)).L - rgbToOklch(hexToRgb(fill)).L);
      fill = dD <= dL ? dark : light; on = onColor(fill);
      report.push('Primária ajustada para ' + fill + ' para manter AA no texto do botão.');
    }
    var sc = scale(action);
    var text = pushUntil(action, PAGE, 4.5, -1);           /* links, aba ativa, contorno: AA em branco e areia */
    var o = rgbToOklch(hexToRgb(action));
    var subtle = oklchToHex({ L: 0.965, C: Math.min(o.C * 0.3, 0.03), H: o.H });
    var subtleHover = oklchToHex({ L: 0.935, C: Math.min(o.C * 0.4, 0.04), H: o.H });
    var border = oklchToHex({ L: 0.84, C: Math.min(o.C * 0.6, 0.09), H: o.H });
    var onSubtle = pushUntil(text, subtle, 4.5, -1);
    var vars = {
      '--ow-primary': fill,
      '--ow-primary-hover': state(fill, on, 'hover'),
      '--ow-primary-pressed': state(fill, on, 'pressed'),
      '--ow-on-primary': on,
      '--ow-primary-text': text,
      '--ow-primary-subtle': subtle,
      '--ow-primary-subtle-hover': subtleHover,
      '--ow-on-primary-subtle': onSubtle,
      '--ow-primary-border': border,
      '--ow-focus-ring-color': text,
      '--ow-brand': brand,
      '--ow-on-brand': onColor(brand)
    };
    Object.keys(sc.steps).forEach(function (k) { vars['--ow-primary-' + k] = sc.steps[k]; });
    var acc = secondary || sc.steps['400'];
    vars['--ow-accent'] = acc;
    vars['--ow-on-accent'] = onColor(acc);
    var t = hexToRgb(input.textColor) ? rgbToHex(hexToRgb(input.textColor)) : null;
    var heading = t && contrast(t, WHITE) >= 4.5 && contrast(t, PAGE) >= 4.5 ? t : INK;
    if (t && heading !== t) report.push('Cor de texto ' + t + ' sem contraste AA: títulos usam o preto padrão.');
    vars['--ow-heading'] = heading;
    return { vars: vars, guard: guard, anchor: sc.anchor, report: report };
  }
  function applyTenantTheme(el, input) {
    var r = deriveTenantTheme(input); el = el || document.documentElement;
    Object.keys(r.vars).forEach(function (k) { el.style.setProperty(k, r.vars[k]); });
    return r;
  }
  return { deriveTenantTheme: deriveTenantTheme, applyTenantTheme: applyTenantTheme, contrast: contrast, oklch: function (h) { return rgbToOklch(hexToRgb(h)); }, DEFAULT_PRIMARY: DEFAULT_PRIMARY };
})();

export const deriveTenantTheme = OWTheme.deriveTenantTheme;
export const applyTenantTheme = OWTheme.applyTenantTheme;
export const contrast = OWTheme.contrast;
export const DEFAULT_PRIMARY = OWTheme.DEFAULT_PRIMARY;
export default OWTheme;
